// Need to use the React-specific entry point to import createApi
import fetchBaseQuery from '@features/WordPress/utilities/fetchBaseQuery';
import { createApi } from '@reduxjs/toolkit/query/react';
import { transformResponse } from '@utilities/api';

// Define a service using a base URL and expected endpoints
export const wordpressApi = createApi({
  reducerPath: 'wordpressApi',
  baseQuery: fetchBaseQuery,
  endpoints: (builder) => ({
    /**
     * Get a subscription
     */
    getSubscriptions: builder.query({
      query: ({ country = '', business = false }) =>
        `subscriptions?country=${country}&business=${business ? '1' : '0'}`,
      transformResponse,
    }),

    /**
     * Get IP location
     */
    getIPLocation: builder.query({
      query: (ip = '') => `ip-location?ip=${ip}`,
      transformResponse: (response) => response?.coordinates || {},
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetSubscriptionsQuery, useGetIPLocationQuery } = wordpressApi;
